import React from 'react';
import { useParams } from 'react-router';

import Form from '../../../../../components/form';
import DealType from '../../../../../enums/deal-type';
import TabsKeys from '../../../../../enums/tab-keys';
import { WAREHOUSE_MOVEMENT_INDEX } from '../../../../../router/routes';
import { route } from '../../../../../services/utils';
import { useDealState } from '../use-deal-state';
import useViewFooter from '../use-view-footer';
import { useRecycledForm } from './use-recycled-form';
import Deal from '../../../../../interfaces/deal';
import RecycleDeal from '../../../../../interfaces/recycle-deal';

const MODE = 'view';

export default function ViewRecycled() {
  const { farmId } = useParams<{ farmId: string }>();

  const dealState: Deal | RecycleDeal = useDealState(DealType.recycled);
  const body = useRecycledForm(MODE);
  const footer = useViewFooter(dealState);

  return (
    <Form
      title={'pages.warehouse.deals.view-deal'}
      backTo={route(WAREHOUSE_MOVEMENT_INDEX, { farmId, tab: TabsKeys.deals })}
      mode={MODE}
      body={body}
      footer={footer}
      values={dealState}
    />
  );
}
